import { Pipe, PipeTransform } from '@angular/core';
import { FileRestrictions } from '@progress/kendo-angular-upload';

@Pipe({
  name: 'acceptFiles',
})
export class AcceptFilesPipe implements PipeTransform {
  transform(fileRestrictions: FileRestrictions): string {
    return fileRestrictions?.allowedExtensions?.join();
  }
}
